import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import ja from 'date-fns/locale/ja'
import format from 'date-fns/format'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import { ScheduledItemTemplate } from 'components/Templates'

const ScheduledItem: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const dateString = /\/scheduled_item\/.+/.test(pathname) ? pathname.split('/scheduled_item/')[1] : undefined
  const date = dateString ? parseToDate(dateString) : new Date()
  const title = format(date, 'M月d日（E）販売予定の商品', { locale: ja })

  return (
    <Layout title={title}>
      <ScheduledItemTemplate date={date} title={title} />
    </Layout>
  )
}

export default ScheduledItem
